import React from 'react';

const BESkills = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Back End Skills</h3>
            </div>
            <div className="skills-info">
                <h4>Python</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>Django</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>Node.js</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>Django Rest Framework</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>RESTful APIs</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>Graph QL APIs</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>Pandas and NumPy</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
            </div>
        </React.Fragment>
    );
};

export default BESkills;